import { Link } from "react-router-dom";
import { Youtube, Phone, Mail, MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { waLink } from "@/lib/whatsapp";

export default function Footer() {
  const { settings } = useSettings();
  const brand = settings?.brand?.name || "NewStarAds";
  const contact = settings?.contact || {};
  const wa = settings?.whatsapp || {};
  const about = settings?.footer?.about || "";
  const social = settings?.social || {};

  return (
    <footer className="bg-slate-950 text-slate-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid gap-12 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 font-display font-extrabold text-xl text-white">
              <span className="grid place-items-center w-8 h-8 rounded-lg bg-primary text-white">
                <Youtube className="w-5 h-5" />
              </span>
              {brand}
            </Link>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">{about}</p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold text-slate-500 mb-4">Services</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/services/youtube-video-promotion" className="hover:text-white transition-colors">Video Promotion</Link></li>
              <li><Link to="/services/youtube-ads" className="hover:text-white transition-colors">Ads Management</Link></li>
              <li><Link to="/services/youtube-seo" className="hover:text-white transition-colors">YouTube SEO</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">All Services</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold text-slate-500 mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold text-slate-500 mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm">
              {contact.phone && (
                <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-primary" /><a href={`tel:${contact.phone.replace(/\s/g,"")}`} className="hover:text-white">{contact.phone}</a></li>
              )}
              {contact.email && (
                <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-primary" /><a href={`mailto:${contact.email}`} className="hover:text-white">{contact.email}</a></li>
              )}
              <li>
                <a href={waLink(wa.number, wa.default_message)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-1 text-green-400 hover:text-green-300">
                  <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="font-display font-black text-4xl sm:text-6xl text-white/5 tracking-tighter select-none">{brand}</p>
          <div className="mt-6 flex flex-col sm:flex-row justify-between gap-4 text-xs text-slate-500">
            <p>© {new Date().getFullYear()} {brand}. All rights reserved. Results vary — we never guarantee views or subscribers.</p>
            <div className="flex flex-wrap gap-4">
              <Link to="/privacy-policy" className="hover:text-slate-300">Privacy</Link>
              <Link to="/terms" className="hover:text-slate-300">Terms</Link>
              <Link to="/refund-policy" className="hover:text-slate-300">Refund</Link>
              <Link to="/disclaimer" className="hover:text-slate-300">Disclaimer</Link>
              <Link to="/cookie-policy" className="hover:text-slate-300">Cookies</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
